/* eslint class-methods-use-this: "off" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-select/async';
import autocompleteItem from 'components/snippets/autocompleteItem';
import autocompleteMenu from 'components/snippets/autocompleteMenu';
import autocompleteMenuList from 'components/snippets/autocompleteMenuList';
import Lang from 'libraries/Lang';

class CruiseRiverPorts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cacheOptions: null,
            destination: props.destination,
            xhr: null,
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.filter = this.filter.bind(this);
    }

    componentDidMount() {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/autocompletes/cruise-river-ports');
        this.setState({ xhr });
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = JSON.parse(xhr.response);
                this.setState({ portsList: data }, () => {
                    const test = this.filter('');

                    test.then((cacheOptions) => { this.setState({ cacheOptions }); });
                });
            } else {
                console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            }
        };
        xhr.onerror = () => {
            console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        };
        xhr.send();
    }

    componentDidUpdate() {
        if (this.props.destination !== this.state.destination) {
            if (this.state.xhr !== null) {
                this.state.xhr.abort();
            }

            const xhr = new XMLHttpRequest();
            xhr.open('GET', `/api/autocompletes/cruise-ports/${this.props.destination.join('|')}`);
            this.setState({ xhr, destination: this.props.destination });
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    const data = JSON.parse(xhr.response);
                    this.setState({ portsList: data }, () => {
                        const test = this.filter('');

                        test.then((cacheOptions) => { this.setState({ cacheOptions }); });
                    });
                } else {
                    console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
                }
            };
            xhr.onerror = () => {
                console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            };
            xhr.send();

            // this.setState({ destination: props.destination });
        }
    }

    onChange(item, action) {
        if (action.action === 'select-option' || action.action === 'remove-value' || action.action == 'clear') {
            this.props.onSelect(item);
        }
    }

    onBlur() {
        this.props.onVisibilityChange(false);
    }

    getDataItem(dataID) {
        const idParts = dataID.split('-');
        const { destinationList } = this.state;
        let item = destinationList;

        for (let i = 0, len = idParts.length; i < len; i++) {
            if (item[idParts[i]]) {
                item = item[idParts[i]];
            } else {
                item = null;
                break;
            }
        }
        return item;
    }

    filter(value = '') {
        return new Promise((resolve, reject) => {
            const { portsList } = this.state;
            const filterList = [];
            const filter = value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
            const regexFilter = new RegExp(filter, 'i');

            portsList.f.forEach((element) => {
                const vendor = portsList.p[element.p];
                const result = {
                    id: vendor.id,
                    text: vendor.text,
                    value: vendor.value,
                    type: vendor.type,
                    displayClass: vendor.displayClass,
                };
                if (regexFilter.test(vendor.text)) {
                    filterList.push(result);
                }
            });

            resolve(filterList);
        });
    }

    render() {
        const { value, placeholder, id } = this.props;
        const styles = {
            menu: () => ({}),
            menuList: () => ({}),
            option: () => ({}),
            valueContainer: (provided) => ({
                ...provided,
                padding: '0 0 0 15px',
                margin: '0px',
                backgroundColor: '#eaecec',
                borderRadius: '8px',
            }),
            placeholder: (provided) => ({
                ...provided,
                color: '#3f3f3f',
                fontWeight: 'bold',
            }),
            singleValue: (provided) => ({
                ...provided,
                color: '3f3f3f',
                fontWeight: 'bold',
            }),
            control: (provided) => ({
                ...provided,
                borderRadius: '0.3rem',
                border: '0',
            }),
            input: (provided) => ({
                ...provided,
                padding: '0px',
                margin: '0px',
                border: 0,
            }),
            dropdownIndicator: (provided) => ({
                ...provided,
                display: 'none',
            }),
            indicatorSeparator: (provided) => ({
                ...provided,
                display: 'none',
            }),
        };

        return (
            <Autocomplete
                inputId={id}
                value={value}
                placeholder={placeholder}
                styles={styles}
                components={{ Option: autocompleteItem, Menu: autocompleteMenu, MenuList: autocompleteMenuList }}
                defaultOptions={this.state.cacheOptions}
                loadOptions={this.filter}
                getOptionLabel={(option) => option.text}
                onBlur={this.onBlur}
                onChange={this.onChange}
                isMulti
                noOptionsMessage={({ inputValue }) => (!inputValue ? Lang.trans('engine.enter_more_characters') : Lang.trans('engine.no_records_found'))}
            />
        );
    }
}

CruiseRiverPorts.propTypes = {
    placeholder: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
    onVisibilityChange: PropTypes.func,
    value: PropTypes.instanceOf(Object),
};

CruiseRiverPorts.defaultProps = {
    onVisibilityChange: () => {},
    value: {},
};

export default CruiseRiverPorts;
